import { storage } from '../firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import logger from '../utils/logger';

export const storageService = {
    /**
     * Uploads a file to Firebase Storage with progress tracking
     * @param {File} file The file object to upload
     * @param {string} path The path in storage
     * @returns {Promise<string>} The download URL
     */
    uploadFile: async (file, path) => {
        return new Promise((resolve, reject) => {
            try {
                logger.info('🚀 [Debug] Starting upload:', { path, size: `${(file.size / 1024).toFixed(2)} KB`, type: file.type });
                const storageRef = ref(storage, path);
                const uploadTask = uploadBytesResumable(storageRef, file);

                uploadTask.on('state_changed', 
                    (snapshot) => {
                        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        logger.info(`📊 [Debug] Upload Progress: ${progress.toFixed(2)}%`, { state: snapshot.state });
                    }, 
                    (error) => {
                        logger.error('❌ [Debug] Upload Error:', error);
                        reject(error);
                    }, 
                    async () => {
                        try {
                            const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                            logger.info('✅ [Debug] Upload Finished! URL:', downloadURL);
                            resolve(downloadURL);
                        } catch (urlError) {
                            logger.error('❌ [Debug] Error getting URL:', urlError);
                            reject(urlError);
                        }
                    }
                );
            } catch (err) {
                logger.error('❌ [Debug] Unexpected error during upload initiation:', err);
                reject(err);
            }
        });
    }
};
